import { render, staticRenderFns } from "./Short_form.vue?vue&type=template&id=47257908&scoped=true&"
import script from "./Short_form.vue?vue&type=script&lang=js&"
export * from "./Short_form.vue?vue&type=script&lang=js&"
import style0 from "./Short_form.vue?vue&type=style&index=0&id=47257908&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47257908",
  null
  
)

export default component.exports